import React from 'react';
import ContentPerformanceFigure from './ContentPerformanceFigure';

const ContentPerformanceFigures = props => (
  <div className="ContentPerformanceFigures">
    <ContentPerformanceFigure
      name="finished"
      for={props.for}
      value={props.finished}
    />
    <ContentPerformanceFigure
      name="score"
      for={props.for}
      value={props.score}
      render={value => `${value}%`}
    />
  </div>
);

export default ContentPerformanceFigures;
